import {map} from 'lodash';
import {useEffect, useState} from 'react';
import {WithTranslation, withTranslation} from 'react-i18next';
import {ResponsiveContainer} from 'recharts';

import {Funnel, FunnelChart} from 'components/recharts';
import {SessionHistoryStatistic} from 'interfaces';

import {ActivityMetric} from '../../enums';
import {ACTIVITY_METRICS_CONFIGS} from '../../metric-config';
import {ActivityMetricConfig} from '../../types';

type Props = {
    statistic: SessionHistoryStatistic;
    metrics: ActivityMetric[];
} & WithTranslation

const ActivityMetricsFunnelChart: React.FC<Props> = ({t, metrics, statistic}: Props) => {
    const [configs, setConfigs] = useState<ActivityMetricConfig[]>([]);
    const [chartData, setChartData] = useState([]);

    useEffect(() => {
        setConfigs(ACTIVITY_METRICS_CONFIGS.filter((config) => metrics.includes(config.metric)));
    }, [metrics]);

    useEffect(() => {
        if (statistic) {
            setChartData(map(configs, (config) => ({
                value: config.valueGetter(statistic),
                fill: config.color,
                fillOpacity: 1,
                name: t(config.title)
            })));
        } else {
            setChartData([]);
        }
    }, [t, statistic, configs]);

    return (
        <ResponsiveContainer>
            <FunnelChart>
                <Funnel
                    dataKey='value'
                    data={chartData}
                    isAnimationActive
                    legendType='line'
                />
            </FunnelChart>
        </ResponsiveContainer>
    );
};

const wrappedComponent = withTranslation()(ActivityMetricsFunnelChart);
export {wrappedComponent as ActivityMetricsFunnelChart};
